import script from "./PSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./PSearch.vue?vue&type=script&lang=ts&setup=true"

import "./PSearch.vue?vue&type=style&index=0&id=0b318dd4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b318dd4"]])

export default __exports__